export default "__VITE_ASSET__Be07_KvM__"